import { getApiGatewayUrl } from "@campgladiator/cg-common.config.config";
import {
  AuthenticatedUserDTO,
  KeanuUserRole,
  AuthToken,
  Request,
} from "@campgladiator/cg-common.types.types";
import { fetchRequest } from "./../";

export const authEndpointBasePath = "/auth/v1";
const authEndpoint = `${authEndpointBasePath}/authorizations`;
const refreshTokenEnpoint = `${authEndpointBasePath}/refresh-tokens`;

export const getAuthorizationByToken = async (
  token: string,
  claims: KeanuUserRole[]
) => {
  const request: Request = {
    requestConfig: {
      method: "POST",
      url: {
        baseUrl: getApiGatewayUrl(),
        endpoint: authEndpoint,
      },
    },
    body: JSON.stringify({
      token,
      claims,
    }),
  };
  const response = await fetchRequest({ request });
  const result = await response.json();

  return response.ok
    ? (result as AuthenticatedUserDTO)
    : Promise.reject(result.message);
};

export const getRefreshToken = async (refreshToken: string) => {
  const request: Request = {
    requestConfig: {
      method: "GET",
      url: {
        baseUrl: getApiGatewayUrl(),
        endpoint: `${refreshTokenEnpoint}/${refreshToken}`,
      },
    },
  };
  const response = await fetchRequest({ request });
  const result = await response.json();

  return response.ok ? (result as AuthToken) : Promise.reject(result.message);
};
